const CONFIRMATION_COPY = {
  title: 'Thanks for signing up!',
  polco: 'Polco',
  description: 'We’re so glad to have you with us.',
  continue: 'Continue',
};

export default CONFIRMATION_COPY;
